module.exports = __webpack_public_path__ + "img/est12.8249160d.jpg";